export default __webpack_public_path__ + "static/hafele-1a7798b9d8217c08f3533d6268d5ed6f.png";